import React from 'react';
import CyberAssociation2025  from 'views/CyberAssociation2025';

const ClassAssembly11CPage = () => {
    return <CyberAssociation2025 />;
  };
  
  export default ClassAssembly11CPage;

  